import User from '../models/user';
import { accountTypes, CENTRAL_TIMETABLER_VIEW_TYPE, FACILITIES_VIEW_TYPE } from '../constants';

export const isUserTypeCentralTimetabler = (user: User, viewType: string) => {
    return user.accountType === accountTypes.centralTimetabler || viewType === CENTRAL_TIMETABLER_VIEW_TYPE;
}

export const isUserTypeFacilities = (user: User, viewType: string) => {
    return user.accountType === accountTypes.facilities || viewType === FACILITIES_VIEW_TYPE;
}